import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";

/** Sections of the Settings sheet that can be deep-linked from elsewhere. */
export type SettingsSection = "flyability";

interface UiState {
  /** When set, the Settings sheet should open and scroll to this section. */
  settingsDeepLink: SettingsSection | null;
}

const initialState: UiState = {
  settingsDeepLink: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openSettings(state, action: PayloadAction<SettingsSection>) {
      state.settingsDeepLink = action.payload;
    },
    clearSettingsDeepLink(state) {
      state.settingsDeepLink = null;
    },
  },
});

export const { openSettings, clearSettingsDeepLink } = uiSlice.actions;

export const settingsDeepLinkSelector = (state: RootState) =>
  state.ui.settingsDeepLink;

export default uiSlice.reducer;
